<script>
  import BlogPage from '$lib/pages/BlogPage.svelte';
</script>

<BlogPage />
